import { useNavigate } from "react-router-dom";
import loginLogo from "../assets/logiscreen.png";
import { useEffect } from "react";
import { detectLogin } from "../helper/generalHelper";

const WelcomeScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // detectLogin(); // Disabled to stop 'automation'
  }, []);

  return (
    <div className="h-screen bg-white flex flex-col items-center justify-center p-6">
      <div>
        <h1 className="text-3xl font-bold text-primary uppercase text-center">
          Stellaries
        </h1>
        <p className="text-sm font-semibold mt-2">Serve More. Stress Less.</p>
      </div>

      <img src={loginLogo} alt="Illustration" className="w-1/3 mt-8" />

      <div className="text-center flex flex-col justify-center items-center ">
        <h2 className="text-lg">
          <span className="text-primary font-bold">Easy</span> Management
          <br />
          For Your Store.
        </h2>

        {/* <button
          onClick={() => navigate("/restaurant/signup")}
          className="bg-primary text-white py-2 px-6 rounded-md mt-6 w-full font-medium"
        >
          Create Account
        </button> */}

        <button
          onClick={() => navigate("/restaurant/signup")}
          className="bg-primary text-white py-2 px-6 rounded-md mt-3 w-full font-medium"
        >
          Get Started
        </button>

        <p className="text-xs mt-4 text-gray-500">
          By logging in or registering, you agree to our
          <br />
          <span className="underline">Terms and Privacy Policy</span>.
        </p>
      </div>
    </div>
  );
};

export default WelcomeScreen;
